import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContainerSolidsLiquidsGases = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 150,
	height: 50,
	viewBox: "0 0 150.0 50.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 150,
		height: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 10.0 0.0 L 10.0 10.0 L 0.0 10.0 M 0.0 40.0 L 10.0 40.0 L 10.0 50.0 M 140.0 0.0 L 140.0 10.0 L 150.0 10.0 M 140.0 50.0 L 140.0 40.0 L 150.0 40.0 M 10.0 10.0 L 140.0 40.0 M 10.0 40.0 L 140.0 10.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgContainerSolidsLiquidsGases;
